var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { AppPaths, ShopLink } from "./AppConfig";
import ProfileEditForm from "./ProfileEditForm";
var RegisterPage = /** @class */ (function (_super) {
    __extends(RegisterPage, _super);
    function RegisterPage(props) {
        return _super.call(this, props) || this;
    }
    RegisterPage.prototype.render = function () {
        var successMessage = React.createElement(React.Fragment, null,
            "Please check your email. Once you've verified your email address, you'll be able to log in. In the mean time, you can ",
            React.createElement(ShopLink, { to: AppPaths.LOCAL_NEW_KIT }, "get started on an order"),
            ".");
        var userParam = (new URLSearchParams(location.search)).get("userReferral");
        var userReferralId;
        if (userParam === null) {
            userReferralId = undefined;
        }
        else {
            userReferralId = userParam;
        }
        var eventParam = (new URLSearchParams(location.search)).get("eventReferral");
        var eventReferralId;
        if (eventParam === null) {
            eventReferralId = undefined;
        }
        else {
            eventReferralId = eventParam;
        }
        return React.createElement("div", { id: "non-header-portion" },
            React.createElement(ProfileEditForm, { buttonIcon: 'user plus', buttonLabel: 'Register', endpoint: '/user/register', includePassword: true, hideOnSuccess: true, successHeader: 'Registration successful', successMessage: successMessage, disableOnSuccess: true, legalInput: true, categoryInput: true, referredByInput: true, sendSignUpGaEvent: true, userReferral: userReferralId, eventReferral: eventReferralId }));
    };
    return RegisterPage;
}(React.PureComponent));
export default RegisterPage;
//# sourceMappingURL=RegisterPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/RegisterPage.js
// module id = 1308
// module chunks = 0